// src/data/desings.js

const projects = [

  {
    id: 1,
  title: "Clipse Grooming Premium",
  description:
    "A premium barber shop template designed for modern grooming brands, featuring appointment booking, service showcases, team profiles, gallery sections, testimonials, and lead generation integration.",
  image: "/images/ClipseGrooming.png",
  github: "https://github.com/RodriguezRamiro/ClipseGrooming",
  demo: "https://barber-template-woad.vercel.app/",
  forSale: true,
  gumroad: "https://rodrigueztechstudios.gumroad.com/",
  tags: [
    "HTML5",
    "CSS3",
    "JavaScript",
    "Responsive Design",
    "Formspree",
    "Dark Mode",
    "Small Business"
  ],
},

  {
    id: 2,
    title: "Luxe Cleaning",
    description: "A luxury website concept tailored specifically around the business brand. Solving visibility, branding, trust, and conversion rate, all in one. ",
    image: "/images/BombshellLuxeCleaning",
    github: "https://github.com/RodriguezRamiro/BombshellLuxeCleaning",
    demo: "https://bombshell-luxe-cleaning.vercel.app/",
    forSale: true,
    gumroad: "https://rodrigueztechstudios.gumroad.com/",
    tags: ["React",
    "CMS Ready",
    "Lead Generation",
    "Mobile First",
    "SEO Optimized"],

  },

  {
    id: 3,
    title: "Nexora Consulting",
    description: "A modern operational framework, helping organizations connect, improve efficiency, visibility, and long-term growth.",
    image: "/images/Nexora Consulting",
    github: "https://github.com/RodriguezRamiro/MidMarketTemplate",
    demo: "https://mid-market-template.vercel.app/index.html",
    forSale: true,
    gumroad: "https://rodrigueztechstudios.gumroad.com/",
    tags: ['React Framework', 'Javascript', 'CSS3'],
  },

  {
    id: 4,
    title: 'SME Business Lead Template',
    description: "Modern professional Lead generation operational framework, allowng organizations to connect, improve efficiency, visibility, and long-term growth.",
    image:"./images/smeTemplate_Tester.png",
    github: "https://github.com/RodriguezRamiro/smeTemplate",
    demo: "https://sme-template.vercel.app/",
    forSale: true,
    gumroad: "https://rodrigueztechstudios.gumroad.com/",
    tags: ['HTML5', 'ES6', 'CSS3', 'JS'],

  },

  {
    id: 5,
    title: " Clips Grooming",
    description: "A barber Shop inspired landing page for a real Small Bussiness Owner built with React and NodeJS.",
    image: "/images/ClipsGrooming.png",
    github: "https://github.com/RodriguezRamiro/clipsgrooming",
    demo: "https://clipsgrooming.vercel.app/",
    forSale: true,
    gumroad: "https://rodrigueztechstudios.gumroad.com/",
    tags: ['React', 'NodeJS', 'CSS'],

  },

  {
    id: 6,
    title: 'E-Commerce',
    description: 'Eshop desinged to browse products, manage a shopping cart, and complete secure checkout with flask backend and scalability of database and payment API integration.',
    image: '/images/pic.png',
    github: 'https://github.com/RodriguezRamiro/ecommerce_app',
    demo: 'https://ecommerce-app-seven-lilac.vercel.app/',
    forSale: true,
    gumroad: "https://rodrigueztechstudios.gumroad.com/",
    tags: ['React', 'Flask', 'CSS','JSON data', 'User Authentication' ],

  },

  {
    id: 7,
    title: 'API_Tester & Todo Dashboard',
    description: "Interactive API testing and Todo dashboard. Full-stack capabilities with a Flask backend, React frontend and live WebSocket",
    image:"./images/API_Tester.png",
    github: "https://github.com/RodriguezRamiro/apitester",
    demo: "https://apitester-fawn.vercel.app/",
    tags: ['React.js', 'Flask', 'Railway.app'],
  },



  // Do not include Yet Project not finished or not needed..
  /*
  {
    id: 5,
    title: 'Snes Ui Lab',
    description: 'A browser-based retro console framework that can load and run cartridge like game desings using a consistent architecture.',
    image: '/images/snessUILab.png',
    github: 'https://github.com/RodriguezRamiro/snessUILab',
    demo: 'https://sness-ui-lab.vercel.app/',
    tags: ['HTML', 'CSS', 'Javascript ES6'],
  },
}
      id: null,
      title: 'Fullstack Blackjack',
      description:'Fullstack Blackjack on React and Flask. Functional multiplayer and real-time chat using Flask-SocketIO.',
      image: "/images/spotify-clone.png",
      github: "https://github.com/RodriguezRamiro/fullstack_blackjack",
      demo: "https://fullstack-blackjack.vercel.app/",
      tags: ['React', 'Flask', 'WebSockets', 'CSS', 'Render'],
  },
    id: 4,
    title: "Spotify Mock Clone",
    description: "A Spotify-inspired music streaming app built with React and Spotify API.",
    image: "/images/spotify-clone.png",
    github: "https://github.com/yourusername/spotify-clone",
    demo: "https://spotify-clone-demo.vercel.app",
    tags: ['React', 'TypeScript'],
  },
  */
];

export default projects;
